import React, { Component } from "react";
import { connect } from "react-redux";
import Router from "./Router/Containers/Router_Cont";
import Snackbar from "./Common/snackbar/components/snackbar";
import { close_snack_bar } from "./Common/snackbar/action";

class App extends Component {
  render() {
    const { snackbar } = this.props;
    return (
      <>
        <Router />
        <Snackbar
          open={snackbar.response_received}
          message={snackbar.message}
          close_snack_bar={this.props.close_snack_bar}
        />
      </>
    );
  }
}

const mapStateToProps = (store) => ({
  snackbar: store.snackbar,
});

const mapDispatchToProps = (dispatch) => ({
  close_snack_bar: () => dispatch(close_snack_bar()),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);